import {
  BodyText,
  SmallBodyText,
  TwoColumnGrid,
  mediumMediaBreakpoint,
  smallMediaBreakpoint,
  spacingM,
  spacingXXL,
} from "@RooUI";
import styled from "styled-components";

export const ContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${smallMediaBreakpoint}) {
    gap: ${spacingXXL};
  }
`;

export const ContactDiv = styled(TwoColumnGrid)`
  grid-template-columns: auto 1fr !important;
  align-items: center;
`;

export const CalendlyContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 304px;
  gap: ${spacingM};

  ul {
    list-style-type: disc;
    padding-inline-start: ${spacingXXL};
  }

  @media (max-width: ${mediumMediaBreakpoint}) {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
  }
`;

export const BodyTextContainer = styled.div`
  ${SmallBodyText}
  gap: ${spacingM};
`;

export const ModalBodyTextContainer = styled.div`
  ${BodyText}
`;
